import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-ad-sign-out',
	templateUrl: './ad-sign-out.component.html',
	styleUrls: ['./ad-sign-out.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AdSignOutComponent implements OnInit, OnDestroy {
	constructor(
		public http: HttpClient,
		private router: Router,
	) {}

	ngOnDestroy(): void {}

	ngOnInit(): void {
		void this.sleep(2000).then(async () => this.router.navigate(['signin']));
	}

	async sleep(milliseconds: number) {
		let resolve: any;
		const promise = new Promise((_resolve) => {
			resolve = _resolve;
		});
		setTimeout(() => resolve(), milliseconds);
		return promise;
	}
}
